const BLOCKS = {
  APP: {
    LOADED: '',
    POPUP: '',
    SCALE: ''
  },
  TEST_PANELS: {
    ACTIVE_TEST: ''
  },
  RECON_PANELS: {
    CURRENT_STEP: ''
  },
  HISTORY_PANELS: {
    CURRENT_LOCATION: '',
    CURRENT_SUBLOCATION: ''
  },
  MAP: {
    NAME: '',
    OFFSET: '',
    CURSOR_POSITION: '',
    GLIDE_PARAMS: '',
    PICKING_MARKER: '',
    ACTIVE_MARKERS: '',
    CROSSHAIR_SETTING: '',
    MARKER_COUNT: ''
  },
  MINI_MAP: {
    NAME: '',
    WITH_TREES: '',
    WITH_LEGENDS: '',
    ZOOM: ''
  },
  MODE: {
    VALUE: ''
  },
  USER_INFO: {
    BALANCE: '',
    USERNAME: ''
  }
};

const divider = ' > ';

setUniqVal(BLOCKS, 'BLOCKS');

export default BLOCKS;

function setUniqVal(obj, pre = '') {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      let val = pre + (pre ? divider : '') + prop;
      if (typeof obj[prop] === 'string') {
        obj[prop] = val;
      } else {
        setUniqVal(obj[prop], val);
      }
    }
  }
}